// src/components/LoginPage.tsx
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '../contexts/SessionContext';
import LoginControl from './session/LoginControl';
import { UserProfile } from '../interfaces';

const LoginPage: React.FC = () => {
  const { dispatch } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [loginError, setLoginError] = useState<string | null>(null);

  const handleLogin = async (data: UserProfile) => {
    try {
      // Dispatch login action
      dispatch({ type: 'LOGIN', payload: { account: data } });

      // Redirect to the original page or default to home page
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    } catch (error) {
      setLoginError('Login failed. Please try again.');
    }
  };

  return (
    <div>
      {loginError && <p>{loginError}</p>}
      <LoginControl onLogin={handleLogin} />
    </div>
  );
};

export default LoginPage;
